import React, { useEffect, useState } from 'react'
import { adminRequest } from '../api/client'
import { BackLink, DetailGrid, SummaryGrid } from '../components/AdminCommon'
import { Card, EmptyState, PageTitle, StatusBadge, formatCurrency, formatDate } from '../components/Ui'

export default function SettlementDetailLive({ id, navigate }) {
  const [batch, setBatch] = useState(null)
  const [error, setError] = useState('')

  useEffect(() => {
    let disposed = false
    setBatch(null)
    setError('')
    adminRequest(`/api/v1/admin/settlements/${encodeURIComponent(id)}`)
      .then((response) => { if (!disposed) setBatch(response?.data || null) })
      .catch((nextError) => { if (!disposed) setError(nextError?.message || '정산 회차를 찾을 수 없습니다.') })
    return () => { disposed = true }
  }, [id])

  if (error) return <><BackLink onClick={() => navigate('/settlements')} /><Card><EmptyState title="정산 조회 실패" description={error} /></Card></>
  if (!batch) return <><BackLink onClick={() => navigate('/settlements')} /><PageTitle eyebrow="SETTLEMENT DETAIL · LIVE DB" title="정산 확인 중" description="difan_dev 정산 원장을 조회하고 있습니다." /><Card><p>실제 정산 회차를 불러오는 중입니다.</p></Card></>

  const rows = batch.items || []
  return <>
    <BackLink onClick={() => navigate('/settlements')} />
    <PageTitle eyebrow="SETTLEMENT DETAIL · LIVE DB" title={batch.batchNo} description={`${batch.periodMonth} 정산 원장입니다. settlement_batches와 settlement_items를 직접 조회합니다.`} />
    <SummaryGrid items={[
      { label: '상태', value: <StatusBadge status={batch.status} /> },
      { label: '총 결제금액', value: formatCurrency(batch.grossAmount) },
      { label: 'PG 수수료', value: formatCurrency(batch.pgFee) },
      { label: '최종 지급액', value: formatCurrency(batch.netAmount) },
    ]} />
    <div className="policy-callout"><strong>실제 정산 원장</strong><span>결제·환불·확정 PG 수수료·조정액을 서버에서 집계한 결과이며 브라우저 localStorage 정산값을 사용하지 않습니다.</span></div>
    <Card title="정산 대상" description="지급계좌는 마스킹된 snapshot만 화면에 노출합니다." className="table-card">
      {rows.length ? <div className="table-scroll"><table className="data-table"><thead><tr><th>디렉터 ID</th><th>주문</th><th>결제금액</th><th>환불</th><th>PG 수수료</th><th>플랫폼 수수료</th><th>조정</th><th>지급액</th><th>지급계좌</th></tr></thead><tbody>{rows.map((row) => <tr key={row.id}><td><small className="mono">{row.directorId}</small></td><td><small className="mono">{row.orderId}</small></td><td>{formatCurrency(row.grossAmount)}</td><td>-{formatCurrency(row.refundAmount)}</td><td>-{formatCurrency(row.pgFee)}</td><td>{formatCurrency(row.platformFee)}</td><td>{Number(row.adjustmentAmount || 0) >= 0 ? '+' : ''}{formatCurrency(row.adjustmentAmount)}</td><td><strong>{formatCurrency(row.netAmount)}</strong></td><td>{row.payoutAccountMasked || '****'}</td></tr>)}</tbody></table></div> : <EmptyState title="집계된 정산 대상이 없습니다." description="회차는 존재하지만 정산 편입 조건을 충족한 거래가 없습니다." />}
    </Card>
    <div className="dashboard-grid half"><Card title="회차 정보"><DetailGrid items={[
      { label: '정산 ID', value: batch.id },
      { label: '정산 월', value: batch.periodMonth },
      { label: '대상 디렉터', value: `${batch.directorCount || 0}명` },
      { label: '환불 합계', value: formatCurrency(batch.refundAmount) },
      { label: '플랫폼 수수료', value: formatCurrency(batch.platformFee) },
      { label: '조정액', value: formatCurrency(batch.adjustmentAmount) },
      { label: '확정 시각', value: formatDate(batch.payableAt, true) },
      { label: '지급 시각', value: formatDate(batch.paidAt, true) },
      { label: '송금 참조번호', value: batch.transferReference || '-' },
    ]} /></Card><Card title="정산 불변 원칙"><ul className="bullet-list"><li>PAID 정산 원장은 직접 수정하지 않음</li><li>사후 환불은 다음 회차 adjustment로 반영</li><li>PG 수수료 확정 전 거래는 정산 대상에서 제외</li><li>민감 계좌 원문은 일반 관리자 화면에 노출하지 않음</li></ul></Card></div>
  </>
}
